const TRUE_VALUES = new Set(['1', 'true', 'yes', 'on']);
const FALSE_VALUES = new Set(['0', 'false', 'no', 'off']);

// Default ON: this is the routing master switch that points the "Communications"
// nav at the new Communications surface (instead of the legacy MessagingTab).
// Explicit opt-out remains for rollback:
//   • REACT_APP_COMMUNICATIONS_HUB_ENABLED in {0,false,no,off}  → forced OFF
//   • localStorage 'cv80_communications_hub_enabled' in {0,...} → forced OFF (per browser)
export function isCommunicationsHubEnabled() {
  const envValue = String(process.env.REACT_APP_COMMUNICATIONS_HUB_ENABLED || '').trim().toLowerCase();
  if (FALSE_VALUES.has(envValue)) return false;
  if (TRUE_VALUES.has(envValue)) return true;

  if (typeof window === 'undefined') {
    return true;
  }

  try {
    const ls = String(window.localStorage.getItem('cv80_communications_hub_enabled') || '').trim().toLowerCase();
    if (FALSE_VALUES.has(ls)) return false;
    if (TRUE_VALUES.has(ls)) return true;
  } catch {
    /* ignore */
  }
  return true;
}
